module.exports = __webpack_public_path__ + "img/image_roadmap.39b64019.png";